import axios from "axios";

const server = process.env.REACT_APP_BACKEND;

const api = axios.create({
  baseURL: server,  // 你的 server 變數
  withCredentials: true,  // 重要！允許跨域請求攜帶憑證
  headers: {
      'Content-Type': 'application/json',
  }
});

const SetUserField = async (user_id, field_id) => {
  let response = await api.post(server + "user/setfield", {
    user_id,
    field_id,
  });
  return response.data;
};
const CreateUser = async (userObj) => {
  let response = await api.post(server + "user/create", userObj);
  return response.data;
};
const UpdateUser = async (userObj) => {
  let response = await api.post(server + "user/update", userObj);
  return response.data;
};
const DeleteUser = async (user_id) => {
  let response = await api({
    method: "DELETE",
    url: server + "user/delete",
    data: { user_id },
  });
  return response.data;
};
const GetUserFields = async (id) => {
  let response = await api.get(server + "user/fields", {
    params: { user_id: id },
  });
  return response.data;
};

const GetUsers = async (level) => {
  let response = await api.get(server + "user/lower", {
    params: { level },
  });
  return response.data;
};

const GetManagers = async () => {
  let response = await api.get(server + "user/managers");
  return response.data;
};

const SetUsers = async (user_id, level) => {
  let response = await api.post(server + "user/setlevel", {
    user_id,
    level,
  });
  return response.data;
};

const TryLogin = async (acc, pwd) => {
  try {
    let response = await api.put(server + "user/login", {
      acc: acc,
      pwd: pwd,
    });
    return response.data;
  } catch (err) {
    return err.response;
  }
};

const CheckToken = async (accessToken) => {
  try {
    let response = await api.put(server + "user/checkToken", {
      accessToken,
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export default {
  TryLogin,
  CheckToken,
  GetUserFields,
  GetUsers,
  GetManagers,
  SetUsers,
  SetUserField,
  CreateUser,
  UpdateUser,
  DeleteUser,
};
